import React, { useState } from 'react'
import Button from './Button'
import { EmptyState, InlineAlert, Skeleton } from './ui'
import '../styles/integration-events.css'

const EVENT_STATUSES = {
  success: { label: 'Успешно', tone: 'success', symbol: '✓' },
  warning: { label: 'Предупреждение', tone: 'warning', symbol: '!' },
  error: { label: 'Ошибка', tone: 'error', symbol: '×' },
  running: { label: 'Выполняется', tone: 'running', symbol: '…' },
  // Пропуск — не ошибка и не успех: runtime намеренно не стал выполнять
  // действие. Причина приходит в details и раскрывается кнопкой «Подробнее».
  skipped: { label: 'Пропущено', tone: 'neutral', symbol: '–' }
}

const DIRECTION_LABELS = {
  amocrm_to_fintablo: 'amoCRM → Финтабло',
  fintablo_to_amocrm: 'Финтабло → amoCRM',
  bitrix24_to_fintablo: 'Bitrix24 → Финтабло',
  fintablo_to_bitrix24: 'Финтабло → Bitrix24'
}

function entityLabel (event) {
  if (event.source_id && event.target_id) return `#${event.source_id} → #${event.target_id}`
  if (event.source_id) return `Источник #${event.source_id}`
  if (event.target_id) return `Результат #${event.target_id}`
  return null
}

function EventRow ({ event }) {
  const [expanded, setExpanded] = useState(false)
  const status = EVENT_STATUSES[event.status] || { label: 'Неизвестный статус', tone: 'neutral', symbol: '•' }
  const entity = entityLabel(event)
  const direction = DIRECTION_LABELS[event.direction] || event.direction

  return (
    <li className='integration-event' data-status={event.status}>
      <span className='integration-event__icon' data-tone={status.tone} aria-hidden='true'>{status.symbol}</span>
      <div className='integration-event__content'>
        <div className='integration-event__title-row'>
          <strong>{event.message}</strong>
          {event.action_required && <span className='integration-event__action'>Требуется действие</span>}
        </div>
        <div className='integration-event__meta'>
          <span className='integration-event__status'>{status.label}</span>
          {direction && <span>{direction}</span>}
          {/* Событие выгрузки прошлых периодов подписано выгрузкой (ADR R20). */}
          {(event.scenario_name || event.export_name) && <span>{event.scenario_name || event.export_name}</span>}
          {entity && <span>{entity}</span>}
        </div>
        {event.details && (
          <div className='integration-event__details'>
            <Button
              aria-expanded={expanded}
              aria-label={expanded ? 'Скрыть детали события' : 'Показать детали события'}
              className='integration-event__details-toggle'
              onClick={() => setExpanded(value => !value)}
              variant='ghost'
            >
              {expanded ? 'Скрыть детали' : 'Подробнее'}
            </Button>
            {expanded && <p>{event.details}</p>}
          </div>
        )}
      </div>
      {event.created_at && <time dateTime={event.created_at}>{new Date(event.created_at).toLocaleString('ru')}</time>}
    </li>
  )
}

export default function IntegrationEventList ({ error = null, items = [], loading = false, onRetry }) {
  if (loading) return <Skeleton className='integration-events__skeleton' aria-label='Загрузка событий' />

  if (error) {
    return (
      <InlineAlert title='Не удалось загрузить события' tone='error'>
        <span>{error}</span>
        {onRetry && <Button className='integration-events__retry' onClick={onRetry} variant='ghost'>Повторить</Button>}
      </InlineAlert>
    )
  }

  if (items.length === 0) {
    return <EmptyState title='Событий пока нет' description='Здесь появятся результаты синхронизации.' />
  }

  return <ul className='integration-events'>{items.map(event => <EventRow event={event} key={event.id} />)}</ul>
}
